import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-stepper',
  imports: [NgTemplateOutlet, CdkStepperModule],
  providers: [{ provide: CdkStepper, useExisting: OnboardingStepperComponent }],
  templateUrl: './onboarding-stepper.component.html',
  styleUrl: './onboarding-stepper.component.scss',
})
export class OnboardingStepperComponent extends CdkStepper {
  public selectStepByIndex(index: number): void {
    this.selectedIndex = index;
  }
}
